import { Container } from './styles';

export default function WhatsAppButton() {
  const phoneNumber = '5542999454922';
  const message = encodeURIComponent('Olá, vim através do seu portifólio!');

  return (
    <Container>
      <div className="whatsapp-button-container">
        <a
          href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/1200px-WhatsApp.svg.png"
            alt="WhatsApp"
            className="whatsapp-icon"
          />
        </a>
      </div>
    </Container>
  );
}
